import { Flex, Form, InputNumber, Switch, Tooltip } from "antd";
import './index.less';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { cdnUrl } from '@/utils/cdn';

interface InputNumberAddonProps {
  symbol: string;
  [key: string]: any;
}

function InputNumberAddon({ symbol, ...restProps }: InputNumberAddonProps) {
  return (
    <div className="input-number-addon-box">
      <InputNumber className="mini-input-number" {...restProps} controls={false} />
      <div className="addon">
        {symbol}
      </div>
    </div>
  );
}

interface RandomTaskTimeProps {
  form: any;
}

export default function RandomTaskTime({ form }: RandomTaskTimeProps) {
  const { t } = useTranslation()
  const bol = form.getFieldValue('openRandomTaskTime');
  const [isRandom, setIsRandom] = useState<boolean>(bol ? bol : false);

  function toggle(val: boolean) {
    setIsRandom(val);
  }

  return (
    <Flex justify="space-between" gap={20}>
      <div className="random-task-time-box">
        <div className="form-items-head">
          <h3>{t("batchSwap.taskIntervalInSeconds")}</h3>
          <div className="form-option">
            <Form.Item name="openRandomTaskTime" label={null} valuePropName="checked">
              <Switch size="small" onChange={toggle} />
            </Form.Item>
            <div className="col-desc">{t("batchSwap.randomDelayTime")}</div>
          </div>
        </div>
        {isRandom ? (
          <div className="form-items">
            <div className="col col-226">
              <Form.Item
                name="randomTaskTimeStart"
                label={null}
                rules={[
                  { type: 'number', min: 1, max: 300 },
                  {
                    validator: (_: any, value: number) => {
                      const endValue = form.getFieldValue('randomTaskTimeEnd');
                      if (value >= 1 && (!endValue || value < endValue)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(t("batchSwap.mustBeLessThanEndTimeAndMinimumOf1"));
                    }
                  }
                ]}
              >
                <InputNumber className="mini-input-number" min={1} max={300} controls={false} />
              </Form.Item>
            </div>
            <span className="span-12" style={{ position: "relative", top: "-10px" }}>~</span>
            <div className="col col-226">
              <Form.Item
                name="randomTaskTimeEnd"
                label={null}
                rules={[
                  { type: 'number', min: 2, max: 300 },
                  {
                    validator: (_: any, value: number) => {
                      const startValue = form.getFieldValue('randomTaskTimeStart');
                      if (!startValue || value > startValue) {
                        return Promise.resolve();
                      }
                      return Promise.reject(t("batchSwap.endTimeMustBeGreaterThanStartTime"));
                    }
                  }
                ]}
              >
                <InputNumber className="mini-input-number" min={2} max={300} controls={false} />
              </Form.Item>
            </div>
          </div>
        ) : (
          <div className="form-items">
            <div className="col one-col">
              <Form.Item
                name="fixedTaskTime"
                label={null}
                rules={[
                  { type: 'number', min: 1, max: 300, message: t("multiSwap.minimumOf1") }
                ]}
              >
                <InputNumber className="mini-input-number" min={1} max={300} controls={false} />
              </Form.Item>
            </div>
          </div>
        )}
      </div>
      <div className="threads">
        <div className="form-items-head">
          <h3>{t("batchSwap.threads")}</h3>
          <Tooltip
            title={t("batchSwap.threadsExplain")}
          >
            <img src={cdnUrl("/img/remind-icon.svg")} alt="" />
          </Tooltip>
        </div>
        <div className="col one-col">
          <Form.Item
            name="threads"
            label={null}
            rules={[
              { type: 'number', min: 1, max: 300, message: t("multiSwap.minimumOf1") }
            ]}
          >
            <InputNumber className="mini-input-number" min={1} max={20} controls={false} />
          </Form.Item>
        </div>
      </div>
    </Flex>
  );
}
